import React, { useState } from "react";
import "./ProjectReviewTable.scss";
import { useNavigate } from "react-router-dom";

// start import for materialUI
import AlertDialog from "../GeneralComponents/AlertDialog";
// end import for materialUI

const ProjectReviewTable = ({
  employerName,
  startTime,
  endTime,
  selectedItems,
  description,
  employerSignature,
  technicianSignature,
  handleSubmit,
  isOfflineMode,
  inProcess,
  projectId,
  // isReviewReport  in true value means we are review the report not submit, so we hide the submit and edit button
  isReviewReport,
  dateOfReport,
}) => {
  console.log(selectedItems);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  const navigate = useNavigate();

  const handleEditProject = () => {
    navigate(
      `/projects/projectsDetails?employer=${employerName}&projectId=${projectId}&offlineMode=${isOfflineMode}`
    );
  };

  return (
    <div className="form-container page-content-center">
      <div className="mt-2">گزارش پروژه: {employerName}</div>
      <div className="time-container">
        <div className="time">
          <span>شروع پروژه</span>
          <span>{startTime}</span>
        </div>
        <div className="time">
          <span>اتمام پروژه</span>
          <span>{endTime}</span>
        </div>
      </div>
      {dateOfReport && <div>{dateOfReport}</div>}
      <table className="table ">
        <tr>
          <th>ردیف</th>
          <th>نام اقلام</th>
          <th>تعداد</th>
          <th>واحد</th>
        </tr>

        {selectedItems?.map((item, index) => {
          return (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.itemName}</td>
              <td>{item.itemValue}</td>
              <td>{item.itemUnit}</td>
            </tr>
          );
        })}
        {description && (
          <tr className="tr-description">
            <td colSpan="4">
              <span>توضیحات:</span>
              <span>{description}</span>
            </td>
          </tr>
        )}
      </table>

      <div className="signatures-container my-3">
        <div className="signature">
          <h4>امضا کارفرما:</h4>
          <img
            src={
              isReviewReport
                ? `https://sapg.ir${employerSignature}`
                : employerSignature
            }
            alt="employer signature"
          />
        </div>
        <div className="signature">
          <h4>امضا سرپرست:</h4>
          <img
            src={
              isReviewReport
                ? `https://sapg.ir${technicianSignature}`
                : technicianSignature
            }
            alt="technician signature"
          />
        </div>
      </div>
      {isReviewReport === true ? null : (
        <>
          <button
            onClick={handleSubmit}
            disabled={inProcess}
            className="my-3 w-50 custom-button-green"
          >
            {isOfflineMode
              ? "ثبت پیش نویس گزارش"
              : inProcess
              ? "در حال ارسال گزارش"
              : "ثبت نهایی گزارش"}
          </button>
          <button
            onClick={() => setDialogIsOpen(true)}
            className="my-3 w-50 custom-button-danger mb-4"
          >
            ویرایش گزارش
          </button>
        </>
      )}

      <AlertDialog
        showAlert={dialogIsOpen}
        title="آیا پروژه ویرایش شود؟"
        description="درصورتی که پروژه را ویرایش نمایید، نیاز است تا امضاها مجددا ثبت گردند، آیا از ویرایش پروژه مطمین هستید؟"
        acceptButtonText="ویرایش پروژه"
        rejectButtonText="انصراف"
        acceptButtonFunction={() => handleEditProject()}
        rejectButtonFunction={() => setDialogIsOpen(false)}
      />
    </div>
  );
};

export default ProjectReviewTable;
